import React, { memo, useMemo, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useIntl, getLocale } from 'umi';
// @ts-ignore
import { isEqual } from 'lodash-es';
import BaseEchart from '../BaseEchart';
import useData from './hooks/useData';
import useDataExtend from './hooks/useDataExtend';
import { seriesNameFormatter } from '../formatters';
import './index.scss';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';

const DEFAULT_PROPS: StackBarEchartsPropsTypes = {
  data: null,
  ignoreSortNames: [],
  tooltipPosition: 'right',
  fontSize: 12,
  tooltipHeaderRightTitle: '',
};

const StackBarEcharts: React.ForwardRefRenderFunction<IGlobalViewPieEChartInstance, StackBarEchartsPropsTypes> = (props, ref) => {
  const { data, ignoreSortNames, tooltipPosition, tooltipHeaderRightTitle, fontSize } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;
  // 计算上下padding及echarts容器高度
  const { verticalPadding, echartsContainerHeight } = useMemo(() => {
    const res = {
      verticalPadding: 22,
      echartsContainerHeight: 80,
    };
    const dataLen = data?.length || 0;
    if (dataLen > 2) {
      // 从第二根开始，每增加一根上下padding减去3，上下padding最小保留5px
      let h = (dataLen - 2) * 3;
      h = h > 17 ? 17 : h; // 22 - 17 = 5
      res.verticalPadding = 22 - h;
      res.echartsContainerHeight = 80 + h * 2;
    }

    return res;
  }, [data?.length]);

  const {
    height,
    data: orgDataOriginal,
    isNoData,
  } = useData({
    isCN,
    data,
    ignoreSortNames,
    seriesNameFormatter,
    tooltipPosition,
    tooltipHeaderRightTitle,
    echartsContainerHeight,
    fontSize,
  });

  const barChartInstances = useRef<any[]>([]);
  const [isChartInited, setIsChartInited] = useState(false);
  const {
    data: orgData,
    onHighlight,
    onDownplay,
  } = useDataExtend({
    data: orgDataOriginal,
    chartsInstances: barChartInstances,
  });
  const handleChartInit = (idx: number, chartInstance: any, chartDom: any) => {
    barChartInstances.current[idx] = chartInstance;
    if (idx === orgData?.length - 1) {
      setIsChartInited(true);
    }
  };

  useImperativeHandle(ref, () => ({
    onHighlight,
    onDownplay,
  }), [
    onHighlight,
    onDownplay,
  ]);

  return (
    <hgroup
      className="dbi-stack-bar-echarts-box"
      style={{
        padding: `${verticalPadding}px 0`,
        border: isNoData ? '0' : '',
      }}
    >
      {!isNoData &&
        orgData?.map((t, i) => <BaseEchart key={i} echartsBoxStyle={{ height }} echartsOptions={t?.options} onInit={(chartInstance: any, chartDom: any) => { handleChartInit(i, chartInstance, chartDom) }} />)}
      {isNoData && <label className="dbi-stack-bar-echarts-box-no-data">{formatMessage({ id: 'common_nodata' })}</label>}
    </hgroup>
  );
};

StackBarEcharts.defaultProps = DEFAULT_PROPS;

export default memo(forwardRef(StackBarEcharts), (prevProps: any, nextProps: any) => isEqual(prevProps, nextProps));
